// menucomponent/ItemDetailsModal.js
import React from "react";

export default function ItemDetailsModal({ selectedItem, closeDetails, colorsState, getCartQuantity, addToCart, removeFromCart }) {
  return (
    <div className="modal fullscreen" role="dialog" aria-modal="true">
      <div className="modal-inner">
        <button className="menu-back-arrow" onClick={closeDetails}>&larr;</button>
        <button className="close-btn" onClick={closeDetails}>×</button>
        <h3 className="menu-detail-title">{selectedItem.name}</h3>
        <hr className="menu-separator" />
        <img src={selectedItem.image} alt={selectedItem.name} className="menu-detail-image" />
        <div className="menu-detail-section">
          <h4>Description</h4>
          <p dangerouslySetInnerHTML={{ __html: selectedItem.description }} />
        </div>
        <hr className="menu-separator" />
        <div className="menu-detail-section">
          <h4>Price</h4>
          <p>₹ {Number(selectedItem.price).toFixed(0)}</p>
        </div>
        <hr className="menu-separator" />
        <div className="menu-detail-section">
          <h4>Diet</h4>
          <p>{selectedItem.diet === "veg" ? "Vegetarian" : "Non-Vegetarian"}</p>
        </div>
        <div className="modal-actions">
          <div className="menu-controls">
            <button
              className="menu-qty-btn"
              onClick={(e) => {
                e.stopPropagation();
                removeFromCart(selectedItem);
              }}
              aria-label={`Remove ${selectedItem.name} from cart`}
            >
              −
            </button>
            <span className="menu-qty">{getCartQuantity(selectedItem.name)}</span>
            <button
              className="menu-add-btn"
              onClick={(e) => {
                e.stopPropagation();
                addToCart(selectedItem);
              }}
              aria-label={`Add ${selectedItem.name} to cart`}
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
